<template>
  <div class="no-viewers">
    <div class="no-viewers__avatar">
      <div class="animoji">
        <img :class="{'grayscale' : message === 'offline'}" src="../assets/animoji/fox.png" />
      </div>
    </div>
    <p class="lighten py-8" v-html="messages[message]"></p>
  </div>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {
      messages: {
        online:
          this.$t('statusOnline'),
        offline:
          this.$t('statusOffline'),
      },
    };
  },
};
</script>

<style lang="scss">
.no-viewers {
  text-align: center;
  &__avatar {
    margin: 0 auto;
    max-width: 100px;
  }
}
</style>
